import React from 'react';
import styles from '../../styles/components/answers/LongAnswer.module.css';

export interface LongAnswerData {
  preselected?: string;
  onCompletion: (text: string | undefined) => void;
  key?: string;
}

export const LongAnswer: React.FC<LongAnswerData> = data => {
  const [selection, setSelection] = React.useState<string | undefined>(
    data.preselected
  );
  return (
    <textarea
      name="textarea"
      value={selection}
      className={styles.textContainer}
      onChange={e => {
        const value = e.target.value.length > 0 ? e.target.value : undefined;
        setSelection(value);
        data.onCompletion(value);
      }}
    ></textarea>
  );
};
